// export function formatIndianPhoneForWhatsApp(rawPhone: string): string {
//   const digits = (rawPhone || "").replace(/\D/g, "");
//   if (digits.length === 10) return `91${digits}`; // bare 10-digit Indian mobile
//   if (digits.length === 12 && digits.startsWith("91")) return digits;
//   return digits; // assume already includes country code
// }

// export type ShareResult =
//   | { method: "web-share" }
//   | { method: "manual-attach" }
//   | { method: "cancelled" };

// export async function shareInvoicePdf(
//   pdfBlob: Blob,
//   fileName: string,
//   customerPhone: string,
//   message: string
// ): Promise<ShareResult> {
//   const file = new File([pdfBlob], fileName, { type: "application/pdf" });

//   // 1) Try the native share sheet first (mobile Chrome/Android, iOS Safari).
//   const nav = navigator as Navigator & {
//     canShare?: (data: { files?: File[] }) => boolean;
//     share?: (data: { files?: File[]; title?: string; text?: string }) => Promise<void>;
//   };

//   if (nav.canShare?.({ files: [file] }) && nav.share) {
//     try {
//       await nav.share({ files: [file], title: fileName, text: message });
//       return { method: "web-share" };
//     } catch (err) {
//       // AbortError = user backed out of the share sheet, not a real failure.
//       if ((err as Error)?.name === "AbortError") return { method: "cancelled" };
//       // Any other failure: fall through to the manual-attach path below.
//     }
//   }

//   // 2) Fallback for desktop Chrome + WhatsApp Web: download PDF, open chat.
//   const url = URL.createObjectURL(pdfBlob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = fileName;
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
//   URL.revokeObjectURL(url);

//   const waNumber = formatIndianPhoneForWhatsApp(customerPhone);
//   const waUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`;
//   window.open(waUrl, "_blank", "noopener,noreferrer");

//   return { method: "manual-attach" };
// }

// export function buildInvoiceWhatsAppMessage(invoiceId: string, customerName: string, grandTotal: number) {
//   return (
//     `Hi ${customerName}, please find your invoice ${invoiceId} attached ` +
//     `(Total: ₹${grandTotal.toLocaleString("en-IN")}). Thank you for your business!`
//   );
// }
export function formatIndianPhoneForWhatsApp(rawPhone: string): string {
  const digits = (rawPhone || "").replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`; // bare 10-digit Indian mobile
  if (digits.length === 12 && digits.startsWith("91")) return digits;
  return digits; // assume already includes country code
}

export type ShareResult =
  | { method: "web-share" }
  | { method: "manual-attach" }
  | { method: "cancelled" };

export async function shareInvoicePdf(
  pdfBlob: Blob,
  fileName: string,
  customerPhone: string,
  message: string
): Promise<ShareResult> {
  const waNumber = formatIndianPhoneForWhatsApp(customerPhone);
  const hasKnownNumber = waNumber.length >= 12;
  if (hasKnownNumber) {
    return openDirectChat(pdfBlob, fileName, waNumber, message);
  }

  const file = new File([pdfBlob], fileName, { type: "application/pdf" });
  const nav = navigator as Navigator & {
    canShare?: (data: { files?: File[] }) => boolean;
    share?: (data: { files?: File[]; title?: string; text?: string }) => Promise<void>;
  };

  if (nav.canShare?.({ files: [file] }) && nav.share) {
    try {
      await nav.share({ files: [file], title: fileName, text: message });
      return { method: "web-share" };
    } catch (err) {
      // AbortError = user backed out of the share sheet, not a real failure.
      if ((err as Error)?.name === "AbortError") return { method: "cancelled" };
      // Any other failure: fall through to the direct-chat path below.
    }
  }

  return openDirectChat(pdfBlob, fileName, waNumber, message);
}
function openDirectChat(pdfBlob: Blob, fileName: string, waNumber: string, message: string): ShareResult {
  const url = URL.createObjectURL(pdfBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);

  const waUrl = waNumber
    ? `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/?text=${encodeURIComponent(message)}`; // no number on file — let the user pick a chat
  window.open(waUrl, "_blank", "noopener,noreferrer");

  return { method: "manual-attach" };
}

export function buildInvoiceWhatsAppMessage(invoiceId: string, customerName: string, grandTotal: number) {
  return (
    `Hi ${customerName}, please find your invoice ${invoiceId} attached ` +
    `(Total: ₹${grandTotal.toLocaleString("en-IN")}). Thank you for your business!`
  );
}